import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CategoryWifiProfileEffects } from './category-wifi-profile-preset-configuration.effects';
import { categoryWifiProfilePresetConfigurationReducer } from './category-wifi-profile-preset-configuration.reducer';

export const provideCategoryWifiProfilePresetConfigurationStore = () => [
  provideState('categoryWifiProfilePresetConfiguration', categoryWifiProfilePresetConfigurationReducer),
  provideEffects([CategoryWifiProfileEffects]),
];
